/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconTriforce: {
  name: 'triforce';
  data: string;
} = {
  name: 'triforce',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 613 613"><path d="M441.449 305.99 576.9 540.598H305.998L441.449 305.99z"/><path d="m170.552 305.99 135.451 234.608H35.101L170.552 305.99z"/><path d="m305.997 71.386 135.451 234.608H170.545L305.997 71.386z"/></svg>`,
};
